import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Link } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { Features } from 'generated/featureDefinitions'

import { observer } from 'mobx-react'

import Callout from 'modules/core/components/Callout'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import SafeLocalStorage from 'modules/core/lib/SafeLocalStorage'
import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'
import AttendanceSettings from 'modules/attendance/store/collections/settings'
import locations from 'modules/locations/store/collections/locations'

const WorkplacesLink = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  return (
    <Link.Touchable
      onClick={() => {
        track('go_to_workplaces', {
          page_referrer: JSON.stringify(navigation.timeTracking.fullPath()),
        })
        navigate(navigation.settings.locations.fullPath())
      }}
    >
      {i18n.t('time_tracking.timezones_notification.link')}
    </Link.Touchable>
  )
}

const NoticeBox = ({ canManageLocation }: { canManageLocation: boolean }) => {
  const [localStorageShowMessage]: [boolean | null, (value: boolean | null) => void] =
    useLocalStorage<boolean>(LOCAL_STORAGE_KEYS.showTimezoneMessage)
  const [showNoticeBox, setNoticeBox] = React.useState(true)
  const { featureAvailability: hasGeoLocationFeature } = useAttendanceFeatures(
    Features.time_tracking_geofencing_alerts
  )
  const hasGeoLocation = hasGeoLocationFeature && AttendanceSettings.hasGeolocation()
  const isAnyTimezoneEmpty = locations.some((loc) => loc.isTimezoneEmpty)
  const isAnyLocationEmpty = locations.some(
    (loc) => !loc.attributes.latitude || !loc.attributes.longitude
  )

  const onClose = () => {
    setNoticeBox(false)
    SafeLocalStorage.setItem(LOCAL_STORAGE_KEYS.showTimezoneMessage, 'false')
  }

  const anyTimezoneEmpty = isAnyTimezoneEmpty && !isAnyLocationEmpty
  const anyLocationEmpty = !isAnyTimezoneEmpty && isAnyLocationEmpty
  const anyTimezoneLocationEmpty = isAnyTimezoneEmpty && isAnyLocationEmpty
  let description = ''

  if (canManageLocation) {
    if (anyTimezoneEmpty)
      description = i18n.t('time_tracking.timezones_notification.description_admin')
    else if (anyLocationEmpty)
      description = i18n.t('time_tracking.timezones_notification.description_admin_address')
    else if (anyTimezoneLocationEmpty)
      description = i18n.t(
        'time_tracking.timezones_notification.description_admin_timezone_address'
      )
  } else {
    if (anyTimezoneEmpty) description = i18n.t('time_tracking.timezones_notification.description')
    else if (anyLocationEmpty)
      description = i18n.t('time_tracking.timezones_notification.description_address')
    else if (anyTimezoneLocationEmpty)
      description = i18n.t('time_tracking.timezones_notification.description_timezone_address')
  }

  if (
    !showNoticeBox ||
    localStorageShowMessage === false ||
    (!isAnyTimezoneEmpty && !hasGeoLocation) ||
    (!isAnyTimezoneEmpty && hasGeoLocation && !isAnyLocationEmpty)
  )
    return null

  return (
    <Box paddingBottom="s16">
      <Callout
        type="critical"
        title={i18n.t('time_tracking.timezones_notification.title')}
        description={description}
        link={canManageLocation ? <WorkplacesLink /> : <></>}
        onRemove={() => onClose()}
      />
    </Box>
  )
}

export default observer(NoticeBox)
